import { useParams } from "react-router-dom";

function BookingPage() {
  const { id } = useParams();

  return (
    <div className="booking-page">
      <h2>Book Service</h2>

      <input placeholder="Your Name" />
      <input placeholder="Mobile Number" />
      <input type="date" />
      <input type="time" />

      <textarea placeholder="Service Description" />

      <button className="top-btn full">
        Confirm Booking
      </button>
    </div>
  );
}

export default BookingPage;
